// <sm-countdown>: 24h evergreen deadline per browser session (HANDOFF 7.5).
// Every countdown on the page reads the same deadline and ticks from one shared interval.
const KEY = 'sm-offer-deadline';
const DAY = 24 * 60 * 60 * 1000;
let memoryDeadline = 0;
const instances = new Set();
let timer = 0;

function deadline() {
  let value = memoryDeadline;
  try { value = Number(sessionStorage.getItem(KEY)) || value; } catch (e) { /* storage blocked */ }
  if (!value || value <= Date.now()) {
    value = Date.now() + DAY;
    try { sessionStorage.setItem(KEY, String(value)); } catch (e) { /* storage blocked */ }
  }
  memoryDeadline = value;
  return value;
}

const pad = (n) => String(n).padStart(2, '0');

function tick() {
  const left = Math.max(0, deadline() - Date.now());
  const h = Math.floor(left / 3600000);
  const m = Math.floor((left % 3600000) / 60000);
  const s = Math.floor((left % 60000) / 1000);
  instances.forEach((el) => el.render(h, m, s));
}

class SmCountdown extends HTMLElement {
  connectedCallback() {
    this.parts = { h: this.querySelector('[data-h]'), m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]') };
    this.lastMinute = -1;
    instances.add(this);
    if (!timer) timer = setInterval(tick, 1000);
    tick();
  }

  disconnectedCallback() {
    instances.delete(this);
    if (!instances.size) { clearInterval(timer); timer = 0; }
  }

  render(h, m, s) {
    if (this.parts.h) this.parts.h.textContent = pad(h);
    if (this.parts.m) this.parts.m.textContent = pad(m);
    if (this.parts.s) this.parts.s.textContent = pad(s);
    if (m !== this.lastMinute && this.dataset.label) {
      // aria-label changes at most once a minute
      this.lastMinute = m;
      this.setAttribute('aria-label', this.dataset.label.replace('[h]', h).replace('[m]', m));
    }
  }
}

if (!customElements.get('sm-countdown')) customElements.define('sm-countdown', SmCountdown);
